import { render, staticRenderFns } from "./BgCreate.vue?vue&type=template&id=62d4fa2d&scoped=true"
import script from "./BgCreate.vue?vue&type=script&lang=js"
export * from "./BgCreate.vue?vue&type=script&lang=js"
import style0 from "./BgCreate.vue?vue&type=style&index=0&id=62d4fa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4fa2d",
  null
  
)

export default component.exports